'use client';
import { Celebration } from '@/components/celebration';
import { useStepData } from '@/components/stepData';
import { Button, Stack, Typography } from '@mui/material';
import { success } from '@repo/onb-api';
import { COLORS, MaterialIcon, ResultScreen } from '@repo/ui';
import Link from 'next/link';

const PORTAL_BENEFITS = [
  'Consultá el estado de tu préstamo.',
  'Mirá las fechas de vencimiento.',
  'Descargá tu cuponera de pago.',
];

export default function Success({ stepdata: stepDataProp }: { stepdata?: success['variables'] }) {
  const stepData = useStepData(stepDataProp);
  const newCustomer = stepData?.newCustomer || false;

  return (
    <>
      <ResultScreen
        status="success"
        title="¡Ya casi estamos!"
        description="Un asesor podría contactarte a la brevedad para confirmar y transferir tu préstamo digital."
        actions={
          newCustomer ? (
            <Button
              component={Link}
              href={`${process.env.NEXT_PUBLIC_CUSTOMER_ROUTE}retrieve_activation`}
              fullWidth
              variant="contained"
              id="button-account"
            >
              Activar mi cuenta
            </Button>
          ) : (
            <Button
              component={Link}
              href={process.env.NEXT_PUBLIC_CUSTOMER_ROUTE || ''}
              fullWidth
              variant="contained"
              id="button-account"
            >
              Ingresar al Portal de Cliente
            </Button>
          )
        }
      >
        <Stack sx={{ alignItems: 'center', gap: 2 }}>
          <Typography component="h2" variant="h2" sx={{ color: COLORS.text.main }}>
            Accedé a tu Portal de Cliente
          </Typography>
          <Stack component="ul" sx={{ gap: 1, m: 0, p: 0, listStyle: 'none', textAlign: 'left' }}>
            {PORTAL_BENEFITS.map((benefit) => (
              <Stack component="li" key={benefit} direction="row" sx={{ gap: 1, alignItems: 'center' }}>
                <MaterialIcon icon="check" color="primary" aria-hidden="true" />
                <Typography variant="body2">{benefit}</Typography>
              </Stack>
            ))}
          </Stack>
        </Stack>
      </ResultScreen>
      <Celebration />
    </>
  );
}
